module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';
	
	fox.registerWidget('Content_BackLink', {
		requiredFields: ['backLinkProp.value', 'backLinkProp.public'],

		configure: function(options) {
			this.registerOptions('', {
				template: 'sitepage_scene_content_backlink',
				autoRender: false,
				manualRender: true,
				handleWom: {
					render: {
						widget: '@parent',
						event: 'addedToDom',
						callback: fox.bind(function() {
							this.render();
						}, this)
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function() {
			this.callParent('running', arguments);

			var dlPath = this.requireOption('dl');
			if (fox.isString(dlPath)) {
				this.dl = this.rwom1(dlPath);
			} else {
				this.dl = dlPath;
			}
			
			this.dl.addFields(this.requiredFields);
			this.handleEvent(this.dl, 'loaded', this.renderBackLink);
		},

		getBackLink: function() {
			var prop = this.dl.getObjectRelation('backLinkProp'),
				backLink = JSON.parse(prop.getObjectValue('value'));

			if (backLink) {
				backLink.public = prop.getObjectValue('public');
				if (fox.cookie.get('foxref')) {
					backLink.url = backLink.url + '?foxref=' + fox.cookie.get('foxref');
				}
				return backLink;
			}

			return false;
		},

		renderBackLink: function() {
			var pm = this.rwom1('@root #permissionManager');
			var backLink = this.getBackLink();
			var hasAccess = pm.hasAccess('member') || (pm.hasAccess('guest') && !fox.isEmpty(pm.getMemberInfo()));
			if (backLink && (backLink.public || hasAccess)) {
				this.setTemplateOptions(backLink);
			}else{
				this.setTemplateOptions({url:''});
			}
			var self = this;
			setTimeout(function () {
				self.render();
			}, 2000);
		}
	}, 'Widget');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/content/backLink.js
// module id = 855
// module chunks = 4